module.exports = __webpack_public_path__ + "img/academy-i.aa4eadbf.png";